/* MEDICOVI Cart Drawer v3 — Web Components + Section Rendering API */
(function(){
  'use strict';

  // ─── <medicovi-cart> ────────────────────────────────────────────────
  class MedicoviCart extends HTMLElement {
    constructor(){ super(); this._ctrl=null; this._queue=Promise.resolve(); this._lastFocus=null; this._scrollY=0; }
    connectedCallback(){
      if(this._mvcInit) return;
      this._mvcInit = true;
      this.addEventListener('click', this._onClick.bind(this));
      document.addEventListener('keydown', this._onKey.bind(this));
      // Listen for cart updates from Dawn or external
      document.addEventListener('cart:opened', () => this.open());
      // Hook Shopify add-to-cart forms (PDP)
      document.addEventListener('submit', this._onPdpSubmit.bind(this), true);
      // Intercept header cart icon + any /cart link → open drawer instead of navigating
      document.addEventListener('click', this._onCartLink.bind(this), true);
      this._initRotator();
      this._initUpsellFade();
    }
    _onCartLink(e){
      if(e.defaultPrevented) return;
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      const a = e.target.closest && e.target.closest('a[href]');
      if(!a) return;
      const href = a.getAttribute('href') || '';
      // Match /cart, /sk/cart, /cz/cart — but NOT /cart/checkout, /cart/add, /cart?...
      const path = href.split('?')[0].split('#')[0].replace(/\/$/, '');
      if(!/(^|\/)cart$/.test(path)) return;
      e.preventDefault();
      e.stopPropagation();
      this.open();
    }
    open(){
      if(this.hasAttribute('open')) return;
      this._lastFocus = document.activeElement;
      this.setAttribute('open','');
      document.documentElement.classList.add('mvc-drawer-open');
      this._lockScroll();
      setTimeout(() => this.focus(), 100);
    }
    close(){
      this.removeAttribute('open');
      document.documentElement.classList.remove('mvc-drawer-open');
      this._unlockScroll();
      if(this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
    }
    _lockScroll(){
      this._scrollY = window.scrollY || window.pageYOffset;
      document.body.style.position='fixed';
      document.body.style.top = '-'+this._scrollY+'px';
      document.body.style.left='0'; document.body.style.right='0';
      document.body.style.width='100%';
    }
    _unlockScroll(){
      document.body.style.position=''; document.body.style.top='';
      document.body.style.left=''; document.body.style.right=''; document.body.style.width='';
      window.scrollTo(0, this._scrollY);
    }
    _onKey(e){
      if(e.key === 'Escape' && this.hasAttribute('open')){
        this.close();
      }
    }
    _onClick(e){
      // Close
      if(e.target.closest('[data-mvc-close]') || e.target.closest('[data-mvc-backdrop]')){
        this.close(); return;
      }
      // Qty
      const qtyBtn = e.target.closest('[data-mvc-qty]');
      if(qtyBtn){
        const delta = parseInt(qtyBtn.dataset.mvcQty, 10);
        const line = parseInt(qtyBtn.dataset.line, 10);
        const row = qtyBtn.closest('.mvc-it');
        const valEl = row && row.querySelector('[data-qty-value]');
        const val = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
        const next = Math.max(0, val + delta);
        if(valEl) valEl.textContent = String(next);
        this.updateQuantity(line, next);
        return;
      }
      // Remove
      const rm = e.target.closest('[data-mvc-rm]');
      if(rm){
        e.preventDefault();
        this.updateQuantity(parseInt(rm.dataset.mvcRm,10), 0);
        return;
      }
      // Discount toggle
      const dt = e.target.closest('[data-mvc-discount-toggle]');
      if(dt){
        const form = this.querySelector('[data-mvc-discount-form]');
        if(form){
          form.classList.toggle('is-open');
          dt.setAttribute('aria-expanded', form.classList.contains('is-open'));
          if(form.classList.contains('is-open')) form.querySelector('input').focus();
        }
        return;
      }
      // Discount submit
      const dform = e.target.closest('[data-mvc-discount-form]');
      if(dform && e.target.matches('button[type="submit"]')){
        e.preventDefault();
        const code = dform.querySelector('input').value.trim();
        if(code) this.applyDiscount(code);
        return;
      }
      // Upsell add
      const addBtn = e.target.closest('[data-mvc-add]');
      if(addBtn){
        e.preventDefault(); e.stopPropagation();
        const id = addBtn.dataset.mvcAdd;
        const handle = addBtn.dataset.handle;
        const hasVariants = addBtn.dataset.hasVariants === 'true';
        if(hasVariants){
          MedicoviVariantPicker.open(handle);
        } else {
          // Get default variant
          fetch('/products/'+handle+'.js').then(r=>r.json()).then(p=>{
            const v = p.variants && p.variants[0];
            if(v) this.addLine(v.id, 1, null, {}, handle);
          });
        }
        return;
      }
      // Checkout
      if(e.target.closest('[data-mvc-checkout]')){
        e.preventDefault();
        this._goToCheckout();
        return;
      }
      // Parcel shop / subscription openers — handled by their components
    }
    _onPdpSubmit(e){
      const form = e.target;
      if(!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const fd = new FormData(form);
      const id = fd.get('id');
      const quantity = parseInt(fd.get('quantity') || '1', 10);
      const selling_plan = fd.get('selling_plan');
      if(!id) return;
      this.addLine(id, quantity, selling_plan);
    }
    _cartFetch(url, body){
      const sections = ['cart-drawer-v3','cart-drawer-items-v3','cart-drawer-totals-v3'];
      const payload = Object.assign({}, body, { sections: sections.join(','), sections_url: '/cart' });
      return this._queue = this._queue.then(async () => {
        if(this._ctrl) this._ctrl.abort();
        this._ctrl = new AbortController();
        try {
          const res = await fetch(url, {
            method:'POST', signal: this._ctrl.signal,
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify(payload)
          });
          const data = await res.json();
          if(!res.ok) throw data;
          this._swapSections(data.sections);
          // Update header count
          this._updateCount(data.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          return data;
        } catch(err){
          if(err && err.name === 'AbortError') return;
          console.warn('[mvc] cart fetch error', err);
          document.dispatchEvent(new CustomEvent('cart:error', { detail: err }));
        }
      });
    }
    _swapSections(sections){
      if(!sections) return;
      // Swap parent body FIRST (it contains the sub-section targets) so subsequent
      // queries find fresh DOM nodes inside the swapped body.
      const order = ['cart-drawer-v3','cart-drawer-items-v3','cart-drawer-totals-v3'];
      order.forEach(key => {
        const html = sections[key];
        if(!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-section-id="'+key+'"]');
        const live = this.querySelector('[data-section-id="'+key+'"]');
        if(fresh && live){
          live.innerHTML = fresh.innerHTML;
        }
      });
      // Sync empty class
      const isEmpty = !this.querySelector('.mvc-it');
      this.classList.toggle('mvc--empty', isEmpty);
      // Re-init rotator if present
      this._initRotator();
      this._initUpsellFade();
    }
    _initUpsellFade(){
      const track = this.querySelector('.mvc__upsell-track');
      if(!track || track._mvcFadeBound) return;
      track._mvcFadeBound = true;
      const update = () => {
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.classList.toggle('is-end', atEnd);
      };
      track.addEventListener('scroll', update, {passive:true});
      // Initial check after layout
      requestAnimationFrame(update);
    }
    _initRotator(){
      const rotator = this.querySelector('[data-mvc-promo-rotator]');
      if(!rotator || rotator._mvcRotating) return;
      const slides = rotator.querySelectorAll('[data-mvc-promo-slide]');
      if(slides.length < 2) return;
      rotator._mvcRotating = true;
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let idx = 0;
      setInterval(() => {
        idx = (idx + 1) % slides.length;
        slides.forEach((s,i) => s.classList.toggle('is-active', i === idx));
      }, 4500);
    }
    _updateCount(count){
      const n = (typeof count === 'number') ? count : parseInt(count, 10);
      const title = this.querySelector('.mvc__title');
      if(title){
        let el = title.querySelector('.mvc__count');
        if(n > 0){
          if(!el){
            el = document.createElement('span');
            el.className = 'mvc__count';
            title.appendChild(el);
          }
          el.textContent = '('+n+')';
        } else if(el){
          el.remove();
        }
      }
      // Update global header cart badges
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], #CartCount').forEach(b => {
        if(n > 0){ b.textContent = n; b.classList.remove('hidden'); }
        else { b.textContent = ''; }
      });
    }
    async updateQuantity(line, qty){
      const row = this.querySelector('[data-line="'+line+'"]');
      if(row) row.setAttribute('aria-busy','true');
      await this._cartFetch('/cart/change.js', { line: line, quantity: qty });
    }
    async addLine(variantId, quantity = 1, sellingPlan = null, properties = {}, productHandle = null){
      const vid = parseInt(variantId, 10);
      // Auto-apply existing subscription plan to the new line if cart already has any subscription.
      // We match plans across products by selling-plan NAME (e.g. "Polročné" → "Polročné").
      if(!sellingPlan){
        try {
          const r = await fetch('/cart.js', {credentials:'same-origin'});
          const cart = await r.json();
          const items = cart.items || [];
          // Exact variant match wins (Shopify merges same variant + plan into one line)
          const sameVar = items.find(i => i.variant_id === vid && i.selling_plan_allocation);
          if(sameVar && sameVar.selling_plan_allocation && sameVar.selling_plan_allocation.selling_plan){
            sellingPlan = sameVar.selling_plan_allocation.selling_plan.id;
          } else {
            // Cross-product: pick the most common subscribed plan name and try to map it onto the new product
            const subscribed = items.filter(i => i.selling_plan_allocation && i.selling_plan_allocation.selling_plan);
            if(subscribed.length && productHandle){
              const targetName = subscribed[0].selling_plan_allocation.selling_plan.name;
              try {
                const pr = await fetch('/products/' + productHandle + '.js');
                const p = await pr.json();
                const groups = p.selling_plan_groups || [];
                let match = null;
                for(const g of groups){
                  for(const plan of (g.selling_plans || [])){
                    if(plan.name === targetName){ match = plan; break; }
                  }
                  if(match) break;
                }
                if(!match){
                  // Fallback: first plan of first group
                  match = (groups[0] && groups[0].selling_plans && groups[0].selling_plans[0]) || null;
                }
                if(match) sellingPlan = match.id;
              } catch(e){}
            }
          }
        } catch(e){}
      }
      const item = { id: vid, quantity: quantity };
      if(sellingPlan) item.selling_plan = sellingPlan;
      if(properties && Object.keys(properties).length) item.properties = properties;
      await this._cartFetch('/cart/add.js', { items: [item] });
      // If the new line is on a subscription plan, auto-clear any parcel-shop
      // selection (Stripe Subscriptions does not allow parcel-shop delivery).
      if(sellingPlan && window.MedicoviGLS && window.MedicoviGLS.clear){
        try { await window.MedicoviGLS.clear(); } catch(e){}
      }
      this.open();
    }
    _showShipError(msg){
      let row = this.querySelector('medicovi-parcel-shop');
      if(!row) return;
      let err = row.querySelector('.mvc__ship-error');
      if(!err){
        err = document.createElement('div');
        err.className = 'mvc__ship-error';
        err.setAttribute('role','alert');
        row.insertAdjacentElement('afterend', err);
      }
      err.textContent = msg;
      err.classList.add('is-visible');
      // Shake the trigger row for emphasis
      row.classList.remove('mvc__ship--err'); void row.offsetWidth;
      row.classList.add('mvc__ship--err');
      setTimeout(() => { err.classList.remove('is-visible'); row.classList.remove('mvc__ship--err'); }, 4000);
    }
    async _goToCheckout(){
      // Legacy MEDICOVI pattern (gls2): set the cart form ACTION to /cart?<address-querystring>
      // then submit via a `name="checkout"` button. Shopify reads checkout[shipping_address][...]
      // from the URL query string and pre-fills the checkout session.
      try {
        const r = await fetch('/cart.js', {credentials:'same-origin'});
        const cart = await r.json();
        const attrs = cart.attributes || {};
        const addrJson = attrs.glsParcelshopAddressJson || attrs.glsParcelshopAddressJSON;
        const shopName = attrs.glsParcelshopName || attrs.glsParcelShopName;
        const method = attrs.glsShippingMethod;
        const hasSub = (cart.items || []).some(i => i.selling_plan_allocation);
        // Subscription cart always defaults to courier (parcel shop not allowed) → skip validation.
        // Otherwise require an explicit shipping method or selected parcel shop.
        if(!hasSub && !method && !shopName){
          this._showShipError('Vyberte si prosím spôsob doručenia.');
          const parcel = document.querySelector('medicovi-parcel-shop');
          if(parcel && parcel._openSheet) parcel._openSheet();
          return;
        }
        // Subscription cart MUST go to courier — skip any (possibly stale) parcel-shop
        // address pre-fill. Stripe Subscriptions rejects parcel-shop delivery for recurring.
        if(hasSub){
          window.location.href = '/checkout';
          return;
        }
        // Store to localStorage so MyGLS plugin can read it on checkout page
        try { localStorage.setItem('glsCart', JSON.stringify({attributes: attrs, items: cart.items || []})); } catch(e){}
        if(addrJson && shopName){
          let addr = {};
          try { addr = JSON.parse(String(addrJson).replace(/&quot;/g, '"')); } catch(e){}
          const ctry = (addr.country || 'sk').toString().toLowerCase();
          const pairs = [
            ['checkout[shipping_address][address1]', addr.address || addr.street || ''],
            ['checkout[shipping_address][city]',     addr.city || ''],
            ['checkout[shipping_address][zip]',      addr.zipCode || addr.zip || ''],
            ['checkout[shipping_address][country]',  ctry.toUpperCase()]
          ];
          const qs = pairs
            .filter(([k,v]) => v)
            .map(([k,v]) => encodeURIComponent(k) + '=' + encodeURIComponent(v))
            .join('&');
          const form = document.createElement('form');
          form.method = 'post';
          form.action = '/cart?' + qs;
          form.style.display = 'none';
          const btn = document.createElement('button');
          btn.type = 'submit'; btn.name = 'checkout'; btn.value = '';
          form.appendChild(btn);
          document.body.appendChild(form);
          form.submit();
          return;
        }
      } catch(e){ console.warn('[mvc] checkout pre-fill failed', e); }
      window.location.href = '/checkout';
    }
    async applyDiscount(code){
      if(!code) return;
      const trimmed = String(code).trim();
      if(!trimmed) return;
      // Snapshot total_discount before applying
      let discountBefore = 0;
      try {
        const cartBefore = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
        discountBefore = cartBefore.total_discount || 0;
      } catch(e){}
      try {
        // Shopify applies a discount via redirect chain on /discount/CODE.
        // We follow the redirect (which lands on /cart) — that sets the
        // cart_discount cookie + applies the discount to the active cart.
        await fetch('/discount/'+encodeURIComponent(trimmed)+'?redirect=/cart', {
          credentials: 'same-origin',
          redirect: 'follow'
        });
      } catch(e){ console.warn('[mvc] discount apply failed', e); }
      // Re-fetch cart sections to reflect new totals
      await this._cartFetch('/cart/update.js', { attributes: { _mvc_d: String(Date.now()) } });
      // Check if discount improved — if not, show info popup
      try {
        const cartAfter = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
        const discountAfter = cartAfter.total_discount || 0;
        if(discountAfter <= discountBefore){
          this._showDiscountInfo('Ďakujeme za Váš zľavový kód! Pretože zľavové kódy nie je možné kombinovať, systém Vám automaticky aplikoval tú najvyššiu zľavu pre Vašu maximálnu úsporu.');
        }
      } catch(e){}
    }
    _showDiscountInfo(msg){
      let popup = this.querySelector('.mvc__discount-info');
      if(!popup){
        popup = document.createElement('div');
        popup.className = 'mvc__discount-info';
        popup.setAttribute('role', 'status');
        popup.innerHTML = '<span class="mvc__discount-info-text"></span><button type="button" class="mvc__discount-info-ok">OK</button>';
        popup.querySelector('.mvc__discount-info-ok').addEventListener('click', () => {
          popup.classList.remove('is-visible');
        });
        const form = this.querySelector('[data-mvc-discount-form]');
        if(form) form.insertAdjacentElement('afterend', popup);
        else this.querySelector('.mvc__body').appendChild(popup);
      }
      popup.querySelector('.mvc__discount-info-text').textContent = msg;
      popup.classList.add('is-visible');
      clearTimeout(popup._hideTimer);
      popup._hideTimer = setTimeout(() => { popup.classList.remove('is-visible'); }, 7000);
    }
  }
  customElements.define('medicovi-cart', MedicoviCart);

  // ─── <medicovi-variant-picker> ──────────────────────────────────────
  class MedicoviVariantPicker extends HTMLElement {
    static open(handle){
      let el = document.querySelector('medicovi-variant-picker');
      if(!el){
        el = document.createElement('medicovi-variant-picker');
        document.body.appendChild(el);
      }
      el.load(handle);
    }
    constructor(){ super(); this._product=null; }
    connectedCallback(){
      this.addEventListener('click', this._onClick.bind(this));
    }
    async load(handle){
      try {
        const r = await fetch('/products/'+handle+'.js');
        const p = await r.json();
        this._product = p;
        this._render(p);
        requestAnimationFrame(() => {
          this.setAttribute('open','');
          const drawer = document.querySelector('medicovi-cart');
          if(drawer) drawer.classList.add('mvc--dimmed');
          const sheet = this.querySelector('.mvp__sheet');
          const handle = this.querySelector('.mvp__handle');
          if(sheet && handle && window.__mvcAttachDrag){
            window.__mvcAttachDrag(sheet, handle, () => this.close());
          }
        });
      } catch(e){ console.warn('[mvp]', e); }
    }
    close(){
      this.removeAttribute('open');
      const drawer = document.querySelector('medicovi-cart');
      if(drawer) drawer.classList.remove('mvc--dimmed');
    }
    _render(p){
      const opts = p.variants.map(v => {
        const avail = v.available !== false;
        return '<button type="button" class="mvp__opt'+(avail?'':' is-oos')+'" data-vid="'+v.id+'" '+(avail?'':'disabled')+'>'
          + '<span class="mvp__opt-title">'+escapeHtml(v.title)+'</span>'
          + (avail ? '' : '<span class="mvp__opt-price">Vypredané</span>')
          + '</button>';
      }).join('');
      this.innerHTML = '<div class="mvp__backdrop" data-close></div><div class="mvp__sheet">'
        + '<button type="button" class="msp__close-btn" data-close aria-label="Zavrieť"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button>'
        + '<div class="mvp__head">'
        + '<div class="mvp__head-img">'+(p.featured_image?'<img src="'+p.featured_image+'?width=200" alt="">':'')+'</div>'
        + '<div><div class="mvp__head-title">'+escapeHtml(p.title)+'</div><div class="mvp__head-sub">Vyberte si veľkosť · '+formatMoney(p.price_min)+'</div></div>'
        + '</div>'
        + '<div class="mvp__opts-label">Veľkosť</div>'
        + '<div class="mvp__opts">'+opts+'</div>'
        + '</div>';
    }
    _onClick(e){
      if(e.target.closest('[data-close]')){ this.close(); return; }
      const opt = e.target.closest('[data-vid]');
      if(opt){
        const vid = opt.dataset.vid;
        const cart = document.querySelector('medicovi-cart');
        if(cart){ cart.addLine(vid, 1, null, {}, this._product && this._product.handle); this.close(); }
      }
    }
  }
  customElements.define('medicovi-variant-picker', MedicoviVariantPicker);
  window.MedicoviVariantPicker = MedicoviVariantPicker;

  // ─── <medicovi-subscription-picker> ─────────────────────────────────
  // Bottom-sheet that lists available selling_plans for items in the cart
  // and applies the chosen plan to those line items.
  class MedicoviSubscriptionPicker extends HTMLElement {
    static async open(){
      let el = document.querySelector('medicovi-subscription-picker');
      if(!el){
        el = document.createElement('medicovi-subscription-picker');
        document.body.appendChild(el);
      }
      await el.load();
    }
    constructor(){ super(); this._cart = null; this._eligibleLines = []; }
    connectedCallback(){ this.addEventListener('click', this._onClick.bind(this)); }
    async load(){
      try {
        const r = await fetch('/cart.js', {credentials:'same-origin'});
        const cart = await r.json();
        this._cart = cart;
        // Group lines by product, collect first selling_plan_group with plans
        const lines = [];
        cart.items.forEach((it, idx) => {
          const groups = it.product_has_only_default_variant
            ? (it.selling_plan_allocation ? [] : [])
            : [];
          if(it.selling_plan_allocation) return; // already on a plan
          // Fetch product for its selling_plan_groups
          lines.push({ line: idx+1, key: it.key, product_id: it.product_id, title: it.product_title, variant_id: it.variant_id, handle: it.handle });
        });
        // Load product details in parallel
        const detailed = await Promise.all(lines.map(async l => {
          try {
            const pr = await fetch('/products/'+l.handle+'.js');
            const p = await pr.json();
            // Flatten ALL plans across ALL selling_plan_groups (PDP shows every plan).
            const allPlans = [];
            (p.selling_plan_groups || []).forEach(g => {
              (g.selling_plans || []).forEach(plan => {
                if(!allPlans.find(x => x.id === plan.id)) allPlans.push(plan);
              });
            });
            if(allPlans.length === 0) return null;
            return Object.assign({}, l, { group: { selling_plans: allPlans } });
          } catch(e){ return null; }
        }));
        this._eligibleLines = detailed.filter(Boolean);
        this._render();
        requestAnimationFrame(() => {
          this.setAttribute('open','');
          const drawer = document.querySelector('medicovi-cart');
          if(drawer) drawer.classList.add('mvc--dimmed');
          // Drag-to-dismiss
          const sheet = this.querySelector('.msp__sheet');
          const handle = this.querySelector('.msp__handle');
          if(sheet && handle && window.__mvcAttachDrag){
            window.__mvcAttachDrag(sheet, handle, () => this.close());
          }
        });
      } catch(e){ console.warn('[msp]', e); }
    }
    close(){
      this.removeAttribute('open');
      const drawer = document.querySelector('medicovi-cart');
      if(drawer) drawer.classList.remove('mvc--dimmed');
    }
    _render(){
      if(this._eligibleLines.length === 0){
        this.innerHTML = '<div class="msp__backdrop" data-close></div><div class="msp__sheet">'
          + '<div class="msp__handle"></div>'
          + '<div class="msp__close-wrap"><button type="button" class="msp__close" data-close aria-label="Zavrieť">×</button></div>'
          + '<div class="msp__title">Predplatné nie je dostupné</div>'
          + '<p class="msp__empty">Žiadny z produktov v košíku nemá k dispozícii predplatné.</p>'
          + '</div>';
        return;
      }
      // Collect unique selling plans across eligible lines, keyed by name.
      // Pick the plan with highest discount per name. Mark "Obľúbené" on plan with name containing "6" or marked is_recommended.
      const planMap = new Map();
      this._eligibleLines.forEach(l => {
        (l.group.selling_plans || []).forEach(p => {
          const key = p.name;
          if(!planMap.has(key)) planMap.set(key, { plan: p, ids: [], lineIds: [], lines: [] });
          planMap.get(key).ids.push(p.id);
          planMap.get(key).lines.push(l.line);
        });
      });
      const plans = Array.from(planMap.values());
      // Choose "popular" — heuristic: contains "6" or last plan
      let popularIdx = plans.findIndex(p => /6/.test(p.plan.name));
      if(popularIdx < 0) popularIdx = plans.length - 1;
      this._selectedIdx = popularIdx;
      this._plans = plans;
      // Compute current cart total (cents) → use for "celkom"
      const subtotal = this._cart && this._cart.original_total_price ? this._cart.original_total_price : 0;
      const planOpts = plans.map((p, idx) => {
        // First percentage adjustment
        let savePct = 0;
        if(p.plan.price_adjustments && p.plan.price_adjustments[0]){
          const adj = p.plan.price_adjustments[0];
          if(adj.value_type === 'percentage') savePct = parseInt(adj.value, 10);
        }
        const active = idx === popularIdx;
        const popular = idx === popularIdx;
        return ''
          + '<button type="button" class="msp__opt'+(active?' is-active':'')+'" data-msp-opt="'+idx+'">'
          +   '<span class="msp__opt-icon" aria-hidden="true">'
          +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2" stroke-linecap="round"/></svg>'
          +   '</span>'
          +   '<span class="msp__opt-body">'
          +     '<span class="msp__opt-label">'+escapeHtml(p.plan.name)
          +       (popular ? ' <span class="msp__opt-badge">Obľúbené</span>' : '')
          +     '</span>'
          +     '<span class="msp__opt-meta">'
          +       (function(){
                    var name = p.plan.name || '';
                    var desc = '';
                    if(/troj|3\s*mes/i.test(name)) desc = 'Pre intenzívne nosenie';
                    else if(/pol|6\s*mes/i.test(name)) desc = 'Odporúčaná životnosť';
                    else if(/mesa|1\s*mes/i.test(name)) desc = 'Najflexibilnejšie';
                    else if(/rok|12\s*mes/i.test(name)) desc = 'Najnižšia cena';
                    var saveStr = savePct ? '<strong class="msp__opt-save">−'+savePct+' %</strong>' : '';
                    return (desc ? desc + (saveStr ? ' · ' : '') : '') + saveStr;
                  })()
          +     '</span>'
          +   '</span>'
          +   '<span class="msp__opt-check" aria-hidden="true"></span>'
          + '</button>';
      }).join('');
      // Totals box
      const selected = plans[popularIdx];
      let pct = 0;
      if(selected.plan.price_adjustments && selected.plan.price_adjustments[0]){
        const adj = selected.plan.price_adjustments[0];
        if(adj.value_type === 'percentage') pct = parseInt(adj.value, 10);
      }
      const discounted = pct ? Math.round(subtotal * (100 - pct) / 100) : subtotal;
      const savings = subtotal - discounted;
      this.innerHTML = ''
        + '<div class="msp__backdrop" data-close></div>'
        + '<div class="msp__sheet">'
        +   '<button type="button" class="msp__close-btn" data-close aria-label="Zavrieť"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button>'
        +   '<div class="msp__title">Ako často chcete nové vložky?</div>'
        +   '<div class="msp__opts">'+planOpts+'</div>'
        +   '<div class="msp__totals" data-msp-totals>'
        +     '<div class="msp__totals-label">Celkom s predplatným</div>'
        +     '<div class="msp__totals-vals">'
        +       '<div class="msp__totals-now" data-msp-now>'+formatMoney(discounted)+'</div>'
        +       (savings > 0 ? '<div class="msp__totals-old" data-msp-old>'+formatMoney(subtotal)+'</div>' : '')
        +       (savings > 0 ? '<div class="msp__totals-save" data-msp-save>Ušetríte '+formatMoney(savings)+'</div>' : '')
        +     '</div>'
        +   '</div>'
        +   '<div class="msp__fine">Bez záväzkov · pozastavíte alebo zrušíte kedykoľvek</div>'
        +   '<button type="button" class="msp__cta" data-msp-apply>Aktivovať predplatné <span aria-hidden="true">→</span></button>'
        + '</div>';
    }
    _selectOpt(idx){
      if(!this._plans || !this._plans[idx]) return;
      this._selectedIdx = idx;
      this.querySelectorAll('[data-msp-opt]').forEach((el, i) => el.classList.toggle('is-active', i === idx));
      // Update totals
      const subtotal = this._cart && this._cart.original_total_price ? this._cart.original_total_price : 0;
      const selected = this._plans[idx];
      let pct = 0;
      if(selected.plan.price_adjustments && selected.plan.price_adjustments[0]){
        const adj = selected.plan.price_adjustments[0];
        if(adj.value_type === 'percentage') pct = parseInt(adj.value, 10);
      }
      const discounted = pct ? Math.round(subtotal * (100 - pct) / 100) : subtotal;
      const savings = subtotal - discounted;
      const now = this.querySelector('[data-msp-now]');
      const old = this.querySelector('[data-msp-old]');
      const save = this.querySelector('[data-msp-save]');
      if(now) now.textContent = formatMoney(discounted);
      if(old) old.textContent = formatMoney(subtotal);
      if(save) save.textContent = 'Ušetríte ' + formatMoney(savings);
    }
    async _apply(){
      if(!this._plans || this._selectedIdx == null) return;
      const selected = this._plans[this._selectedIdx];
      const cart = document.querySelector('medicovi-cart');
      if(!cart) return this.close();
      // Apply selected plan to every eligible line whose product offers this plan name
      for(let i = 0; i < this._eligibleLines.length; i++){
        const l = this._eligibleLines[i];
        const planForLine = (l.group.selling_plans || []).find(p => p.name === selected.plan.name);
        if(!planForLine) continue;
        let qty = 1;
        try {
          const r = await fetch('/cart.js', {credentials:'same-origin'});
          const c = await r.json();
          qty = (c.items[l.line-1] && c.items[l.line-1].quantity) || 1;
        } catch(e){}
        await cart._cartFetch('/cart/change.js', { line: l.line, quantity: qty, selling_plan: parseInt(planForLine.id, 10) });
      }
      // Stripe Subscriptions doesn't support parcel-shop delivery → auto-clear it,
      // force courier so checkout shows shipping rates immediately.
      if(window.MedicoviGLS && window.MedicoviGLS.clear){
        try { await window.MedicoviGLS.clear(); } catch(e){}
      }
      this.close();
    }
    async _onClick(e){
      if(e.target.closest('[data-close]')){ this.close(); return; }
      if(e.target.closest('[data-msp-apply]')){ await this._apply(); return; }
      const opt = e.target.closest('[data-msp-opt]');
      if(opt){
        const idx = parseInt(opt.dataset.mspOpt, 10);
        this._selectOpt(idx);
      }
    }
  }
  customElements.define('medicovi-subscription-picker', MedicoviSubscriptionPicker);
  // Global delegated handler for [data-mvc-sub-open]
  document.addEventListener('click', (e) => {
    if(e.target.closest('[data-mvc-sub-open]')){
      e.preventDefault();
      MedicoviSubscriptionPicker.open();
    }
  });

  // ─── <medicovi-parcel-shop> ─────────────────────────────────────────
  // Drawer footer trigger + accordion panel hosting a 2-card shipping picker.
  // The GLS map dialog itself is a singleton at body root (snippets/gls-portal.liquid).
  // Communication via document events:
  //   - dispatch  medicovi:gls:open       to open map
  //   - dispatch  medicovi:gls:clear      to clear parcel-shop attrs
  //   - listen    medicovi:gls:selected   payload {id,name,street,city,zip,country}
  class MedicoviParcelShop extends HTMLElement {
    connectedCallback(){
      this.addEventListener('click', this._onTrigger.bind(this));
      document.addEventListener('medicovi:gls:selected', this._onSelected.bind(this));
      document.addEventListener('medicovi:gls:cleared', this._onCleared.bind(this));
      // Portal the inner panel to body root so it appears as a top-level bottom-sheet,
      // identical pattern to <medicovi-subscription-picker>.
      this._portalPanel();
      this._refreshTriggerFromMarkup();
    }
    _portalPanel(){
      const panel = this.querySelector('[data-mvc-parcel-panel]');
      if(!panel) return;
      panel.removeAttribute('hidden');
      const wrap = document.createElement('div');
      wrap.className = 'mvc-sheet mvc-sheet--ship';
      wrap.setAttribute('role','dialog');
      wrap.setAttribute('aria-modal','true');
      wrap.setAttribute('aria-hidden','true');
      const backdrop = document.createElement('div');
      backdrop.className = 'mvc-sheet__backdrop';
      backdrop.dataset.mvcSheetClose = '1';
      const sheet = document.createElement('div');
      sheet.className = 'mvc-sheet__panel';
      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'mvc-sheet__close';
      closeBtn.dataset.mvcSheetClose = '1';
      closeBtn.setAttribute('aria-label', 'Zavrieť');
      closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>';
      sheet.appendChild(closeBtn);
      sheet.appendChild(panel);
      wrap.appendChild(backdrop);
      wrap.appendChild(sheet);
      document.body.appendChild(wrap);
      this._sheetWrap = wrap;
      wrap.addEventListener('click', (e) => {
        if(e.target.closest('[data-mvc-sheet-close]')){
          this._closeSheet();
          return;
        }
        const card = e.target.closest('[data-mvc-ship-method]');
        if(card){
          e.preventDefault();
          const method = card.dataset.mvcShipMethod;
          this._setActiveCard(method);
          if(method === 'courier'){
            window.MedicoviGLS && window.MedicoviGLS.clear();
            this._clearPacketa();
            this._closeSheet();
          } else if(method === 'parcel'){
            this._clearPacketa();
            window.MedicoviGLS && window.MedicoviGLS.open();
            this._closeSheet();
          } else if(method === 'packeta'){
            window.MedicoviGLS && window.MedicoviGLS.clear();
            this._closeSheet();
            this._openPacketa();
          }
        }
      });
      document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && this._isOpen) this._closeSheet();
      });
    }
    _openPacketa(){
      const key = this.dataset.packetaKey || '';
      if(!key){ console.warn('[mvc] Packeta API key missing'); return; }
      const load = (cb) => {
        if(window.Packeta && window.Packeta.Widget){ cb(); return; }
        const s = document.createElement('script');
        s.src = 'https://widget.packeta.com/v6/www/js/library.js';
        s.onload = cb;
        document.head.appendChild(s);
      };
      load(() => {
        window.Packeta.Widget.pick(key, (point) => {
          if(!point) return;
          this._onPacketaSelected(point);
        }, { country: 'sk', language: 'sk' });
      });
    }
    _onPacketaSelected(point){
      const _pPlace = point.place || '';
      const _pName = point.name || '';
      const displayName = _pPlace && _pName ? _pPlace + ' · ' + _pName : (_pPlace || _pName);
      const attrs = {
        packetaPointId: String(point.id || ''),
        packetaPointName: displayName,
        packetaPointAddress: point.street || point.address || '',
        packetaPointZip: point.zip || '',
        packetaPointCity: point.city || '',
        packetaPointCountry: 'SK',
        pickupCarrier: 'packeta',
        glsShippingMethod: '',
        glsParcelShopHash: '',
        glsParcelshopName: '',
        glsParcelshopAddressJson: ''
      };
      const drawer = document.querySelector('medicovi-cart');
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(() => {
        if(drawer && drawer._cartFetch){
          drawer._cartFetch('/cart/update.js', { attributes: { _mvc_ship: String(Date.now()) } });
        }
        // Update trigger label immediately
        const label = this.querySelector('[data-mvc-parcel-label]');
        const eyebrow = this.querySelector('.mvc__ship-label');
        if(eyebrow) eyebrow.textContent = 'PACKETA';
        if(label) label.innerHTML = displayName.substring(0,32) + ' <span class="mvc__ship-change">· zmeniť</span>';
        this.classList.add('mvc__ship--has');
        this._setActiveCard('packeta');
      }).catch(e => console.warn('[mvc] packeta attr save failed', e));
    }
    _clearPacketa(){
      const hasPacketa = this.dataset.shipState === 'packeta';
      if(!hasPacketa) return;
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          packetaPointId: '', packetaPointName: '', packetaPointAddress: '',
          packetaPointZip: '', packetaPointCity: '', packetaPointCountry: '',
          pickupCarrier: ''
        }})
      }).catch(() => {});
    }
    _onTrigger(e){
      if(e.target.closest('[data-mvc-packeta-open]')){
        e.preventDefault();
        this._openPacketa();
        return;
      }
      if(e.target.closest('[data-mvc-parcel-open]')){
        e.preventDefault();
        this._openSheet();
      }
    }
    _openSheet(){
      if(!this._sheetWrap) return;
      this._sheetWrap.setAttribute('aria-hidden','false');
      this._sheetWrap.classList.add('is-open');
      this._isOpen = true;
      // Dim the cart drawer behind sheet
      const drawer = document.querySelector('medicovi-cart');
      if(drawer) drawer.classList.add('mvc--dimmed');
    }
    _closeSheet(){
      if(!this._sheetWrap) return;
      this._sheetWrap.classList.remove('is-open');
      this._sheetWrap.setAttribute('aria-hidden','true');
      this._isOpen = false;
      const drawer = document.querySelector('medicovi-cart');
      if(drawer) drawer.classList.remove('mvc--dimmed');
    }
    _setActiveCard(method){
      (this._sheetWrap || this).querySelectorAll('[data-mvc-ship-method]').forEach(c => {
        c.classList.toggle('is-active', c.dataset.mvcShipMethod === method);
      });
    }
    _root(){ return this._sheetWrap || this; }
    _onSelected(e){
      const d = (e && e.detail) || {};
      this._setActiveCard('parcel');
      const meta = this._root().querySelector('[data-mvc-ship-parcel-name]');
      if(meta) meta.textContent = (d.name || '') + (d.city ? ' · ' + d.city : '');
      const labelEyebrow = this.querySelector('.mvc__ship-label');
      if(labelEyebrow) labelEyebrow.textContent = 'GLS PARCELSHOP';
      this._refreshTriggerLabel(d.name);
      // Show "Zmeniť pobočku" if missing
      const picker = this._root().querySelector('[data-mvc-ship-picker]');
      if(picker && !picker.querySelector('[data-mvc-gls-open]')){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mvc-bsh__change';
        btn.setAttribute('data-mvc-gls-open','');
        btn.textContent = 'Zmeniť pobočku';
        picker.appendChild(btn);
      }
      this._closeSheet();
    }
    _onCleared(){
      this._setActiveCard('courier');
      const meta = this._root().querySelector('[data-mvc-ship-parcel-name]');
      if(meta) meta.innerHTML = 'Vyzdvihnutie · <strong>ZADARMO</strong> · 4 700+ miest';
      const change = this._root().querySelector('[data-mvc-gls-open]');
      change && change.remove();
      // Trigger row reflects courier selection (cyan-bg pinned state)
      const label = this.querySelector('[data-mvc-parcel-label]');
      const labelEyebrow = this.querySelector('.mvc__ship-label');
      if(labelEyebrow) labelEyebrow.textContent = 'KURIÉR';
      if(label) label.innerHTML = 'GLS Doručenie na adresu <span class="mvc__ship-change">· zmeniť</span>';
      this.classList.add('mvc__ship--has');
    }
    _refreshTriggerFromMarkup(){
      const active = this._root().querySelector('[data-mvc-ship-method].is-active');
      if(!active) return;
      if(active.dataset.mvcShipMethod === 'parcel'){
        const meta = this._root().querySelector('[data-mvc-ship-parcel-name]');
        if(meta) this._refreshTriggerLabel(meta.textContent.trim());
      }
    }
    _refreshTriggerLabel(name, clear){
      const label = this.querySelector('[data-mvc-parcel-label]');
      if(!label) return;
      if(clear){
        label.textContent = 'Vybrať spôsob doručenia';
        this.classList.remove('mvc__ship--has');
        return;
      }
      if(name){
        label.innerHTML = String(name).replace(/[<>]/g,'') + ' <span class="mvc__ship-change">· zmeniť</span>';
        this.classList.add('mvc__ship--has');
      }
    }
  }
  customElements.define('medicovi-parcel-shop', MedicoviParcelShop);

  // ─── <medicovi-all-models> ──────────────────────────────────────────
  // Bottom-sheet "Pozrieť všetky modely" — portalled to body on connect.
  // Inline card → size-chip expansion (Allbirds pattern, no sub-sheets per NN/g).
  class MedicoviAllModels extends HTMLElement {
    connectedCallback(){
      // Portal to body root so the sheet sits above the drawer stacking context.
      // CRITICAL: portal triggers disconnectedCallback → connectedCallback, which
      // would double-bind listeners (toggle fires twice, sizes flash open then close).
      if(this.parentElement !== document.body){
        document.body.appendChild(this);
        return; // exit; reconnect will run this method again with parent === body
      }
      if(this._mvcInit) return;
      this._mvcInit = true;
      this.addEventListener('click', this._onClick.bind(this));
      document.addEventListener('keydown', this._onKey.bind(this));
      // Global delegate: any [data-mvc-all-open] opens this sheet
      document.addEventListener('click', this._onOpenTrigger.bind(this));
    }
    _onOpenTrigger(e){
      const all = e.target.closest && e.target.closest('[data-mvc-all-open]');
      if(all){
        e.preventDefault();
        this._open();
        return;
      }
      // Cross-sell card "Vybrať" → open sheet + auto-expand that product's card
      const xs = e.target.closest && e.target.closest('[data-mvc-xs-open]');
      if(xs){
        e.preventDefault();
        const handle = xs.dataset.mvcXsOpen;
        this._open();
        // Wait a tick for sheet to render, then expand the target card
        setTimeout(() => {
          const card = this.querySelector('[data-mvc-am-card][data-handle="' + handle + '"]');
          if(card){
            // Collapse any other open card
            this.querySelectorAll('[data-mvc-am-card].is-open').forEach(c => {
              if(c !== card){
                c.classList.remove('is-open');
                const s = c.querySelector('.mvc-am__sizes');
                if(s) s.setAttribute('hidden','');
              }
            });
            card.classList.add('is-open');
            const sizes = card.querySelector('.mvc-am__sizes');
            if(sizes) sizes.removeAttribute('hidden');
            card.scrollIntoView({behavior:'smooth', block:'center'});
          }
        }, 150);
      }
    }
    _onKey(e){
      if(e.key === 'Escape' && this._isOpen) this._close();
    }
    _open(){
      this.classList.add('is-open');
      this.setAttribute('aria-hidden','false');
      this._isOpen = true;
      const drawer = document.querySelector('medicovi-cart');
      if(drawer) drawer.classList.add('mvc--dimmed');
    }
    _close(){
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden','true');
      this._isOpen = false;
      // Collapse any open card
      this.querySelectorAll('[data-mvc-am-card].is-open').forEach(c => {
        c.classList.remove('is-open');
        const s = c.querySelector('.mvc-am__sizes');
        if(s) s.setAttribute('hidden','');
      });
      const drawer = document.querySelector('medicovi-cart');
      if(drawer) drawer.classList.remove('mvc--dimmed');
    }
    _onClick(e){
      if(e.target.closest('[data-mvc-sheet-close]')){ this._close(); return; }

      // Toggle card open/close (size picker reveal)
      const toggle = e.target.closest('[data-mvc-am-toggle]');
      if(toggle){
        e.preventDefault();
        const card = toggle.closest('[data-mvc-am-card]');
        if(!card) return;
        const open = !card.classList.contains('is-open');
        // Collapse all other cards
        this.querySelectorAll('[data-mvc-am-card].is-open').forEach(c => {
          if(c !== card){
            c.classList.remove('is-open');
            const s = c.querySelector('.mvc-am__sizes');
            if(s) s.setAttribute('hidden','');
          }
        });
        card.classList.toggle('is-open', open);
        const sizes = card.querySelector('.mvc-am__sizes');
        if(sizes){
          if(open) sizes.removeAttribute('hidden'); else sizes.setAttribute('hidden','');
        }
        if(open){
          // Scroll the card into view inside sheet body
          requestAnimationFrame(() => card.scrollIntoView({behavior:'smooth', block:'center'}));
        }
        return;
      }

      // Size chip → mark selected (don't add yet — wait for confirm)
      const sizeBtn = e.target.closest('[data-mvc-am-size]');
      if(sizeBtn && !sizeBtn.disabled){
        e.preventDefault();
        e.stopPropagation();
        const card = sizeBtn.closest('[data-mvc-am-card]');
        if(!card) return;
        // Toggle: same chip = deselect, different = select that one
        const wasActive = sizeBtn.classList.contains('is-active');
        card.querySelectorAll('.mvc-am__size').forEach(c => c.classList.remove('is-active'));
        if(!wasActive) sizeBtn.classList.add('is-active');
        // Enable/disable confirm
        const confirmBtn = card.querySelector('[data-mvc-am-confirm]');
        if(confirmBtn){
          const selected = card.querySelector('.mvc-am__size.is-active');
          confirmBtn.disabled = !selected;
          confirmBtn.textContent = 'Pridať do košíka';
        }
        return;
      }

      // Confirm "Pridať do košíka · X €" → actually add
      const confirmBtn = e.target.closest('[data-mvc-am-confirm]');
      if(confirmBtn && !confirmBtn.disabled){
        e.preventDefault();
        e.stopPropagation();
        this._confirmAdd(confirmBtn);
        return;
      }
    }
    async _confirmAdd(confirmBtn){
      const card = confirmBtn.closest('[data-mvc-am-card]');
      if(!card) return;
      const selected = card.querySelector('.mvc-am__size.is-active');
      if(!selected) return;
      const vid = selected.dataset.mvcAmSize;
      const handle = confirmBtn.dataset.handle;
      const title = confirmBtn.dataset.title || '';
      const variantTitle = selected.dataset.variantTitle || selected.textContent.trim();
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Pridávam…';
      const drawer = document.querySelector('medicovi-cart');
      if(drawer){
        try {
          await drawer.addLine(vid, 1, null, {}, handle);
        } catch(e){ console.warn('[mvc-am] add failed', e); }
      }
      // Reset card state + collapse (so it doesn't overflow when sheet re-opens later)
      card.classList.remove('is-open');
      const sizes = card.querySelector('.mvc-am__sizes');
      if(sizes) sizes.setAttribute('hidden','');
      card.querySelectorAll('.mvc-am__size.is-active').forEach(c => c.classList.remove('is-active'));
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Pridať do košíka';
      // Refresh footer counter
      this._refreshFooter();
      // Close the entire sheet — user returns to drawer where item is now visible
      this._close();
    }
    _toast(msg){
      const t = this.querySelector('[data-mvc-am-toast]');
      if(!t) return;
      t.textContent = msg;
      t.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => t.classList.remove('is-visible'), 5000);
    }
    async _refreshFooter(){
      try {
        const r = await fetch('/cart.js', {credentials:'same-origin'});
        const cart = await r.json();
        const info = this.querySelector('.mvc-am__foot-info strong');
        const price = this.querySelector('.mvc-am__foot-info small');
        if(info) info.textContent = 'Košík (' + cart.item_count + ')';
        if(price) price.textContent = (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cart.total_price) : ((cart.total_price/100).toFixed(2) + ' €');
      } catch(e){}
    }
  }
  customElements.define('medicovi-all-models', MedicoviAllModels);

  // ─── Dawn compatibility shim ───────────────────────────────────────
  // Dawn's product-form.js does: this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  // then calls this.cart.renderContents(parsedState). If this.cart is null → window.location = cart_url (the /cart redirect).
  // We define <cart-drawer> as a thin shim that forwards to <medicovi-cart>.
  class CartDrawerShim extends HTMLElement {
    constructor(){ super(); this.classList.add('drawer','is-empty'); }
    getSectionsToRender(){
      return [
        { id: 'cart-drawer-items-v3', section: 'cart-drawer-items-v3', selector: '[data-mvc-items]' },
        { id: 'cart-drawer-totals-v3', section: 'cart-drawer-totals-v3', selector: '[data-mvc-totals]' }
      ];
    }
    getSectionInnerHTML(html, selector){
      try { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML; }
      catch(e){ return ''; }
    }
    setActiveElement(el){ this._activeEl = el; }
    renderContents(parsedState){
      const mv = document.querySelector('medicovi-cart');
      if(!mv) return;
      if(parsedState && parsedState.sections){
        try {
          const itemsHtml = parsedState.sections['cart-drawer-items-v3'];
          const totalsHtml = parsedState.sections['cart-drawer-totals-v3'];
          if(itemsHtml){
            const wrap = mv.querySelector('[data-mvc-items]');
            if(wrap) wrap.outerHTML = this.getSectionInnerHTML(itemsHtml, '[data-mvc-items]') ? new DOMParser().parseFromString(itemsHtml,'text/html').querySelector('[data-mvc-items]').outerHTML : wrap.outerHTML;
          }
          if(totalsHtml){
            const wrap = mv.querySelector('[data-mvc-totals]');
            if(wrap) wrap.outerHTML = new DOMParser().parseFromString(totalsHtml,'text/html').querySelector('[data-mvc-totals]').outerHTML;
          }
        } catch(e){ console.warn('[mvc-shim] section swap failed', e); }
      }
      mv.classList.remove('mvc--empty');
      mv.open && mv.open();
    }
    open(){ const mv = document.querySelector('medicovi-cart'); mv && mv.open && mv.open(); }
    close(){ const mv = document.querySelector('medicovi-cart'); mv && mv.close && mv.close(); }
  }
  if(!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawerShim);
  // Ensure an instance exists in DOM so document.querySelector('cart-drawer') returns truthy
  // even before <medicovi-cart> connectedCallback runs.
  function ensureShim(){
    try {
      if(!document.querySelector('cart-drawer')){
        const shim = document.createElement('cart-drawer');
        shim.style.display = 'none';
        (document.body || document.documentElement).appendChild(shim);
      }
    } catch(e){
      // Cookiebot/CMP scripts sometimes wrap createElement and throw on
      // custom-element names with attributes; safe to ignore — Dawn's
      // product-form alias is optional, our document-level submit listener
      // already intercepts /cart/add.
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ensureShim);
  } else {
    ensureShim();
  }
  // Also try immediately in case product-form upgrades before DOMContentLoaded
  try { ensureShim(); } catch(e){}

  // ─── Helpers ────────────────────────────────────────────────────────
  // ─── Drag-to-dismiss helper for bottom sheets ──────────────────────
  function attachDragToDismiss(sheetEl, handleEl, onClose){
    if(!sheetEl || !handleEl) return;
    let startY = 0, currentY = 0, dragging = false;
    const threshold = 90; // px to trigger close
    function start(y){
      dragging = true; startY = y; currentY = 0;
      sheetEl.style.transition = 'none';
    }
    function move(y){
      if(!dragging) return;
      currentY = Math.max(0, y - startY);
      sheetEl.style.transform = 'translateY(' + currentY + 'px)';
    }
    function end(){
      if(!dragging) return;
      dragging = false;
      sheetEl.style.transition = '';
      if(currentY > threshold){
        sheetEl.style.transform = '';
        onClose && onClose();
      } else {
        sheetEl.style.transform = '';
      }
    }
    handleEl.addEventListener('touchstart', e => start(e.touches[0].clientY), {passive:true});
    handleEl.addEventListener('touchmove',  e => move(e.touches[0].clientY),  {passive:true});
    handleEl.addEventListener('touchend',   end);
    handleEl.addEventListener('touchcancel',end);
    handleEl.addEventListener('mousedown',  e => { start(e.clientY); const mv = ev=>move(ev.clientY); const up = ()=>{ end(); document.removeEventListener('mousemove',mv); document.removeEventListener('mouseup',up); }; document.addEventListener('mousemove',mv); document.addEventListener('mouseup',up); });
  }
  window.__mvcAttachDrag = attachDragToDismiss;

  function escapeHtml(s){ return String(s).replace(/[&<>"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c])); }
  function formatMoney(cents){
    try { if(window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents); } catch(e){}
    return ((cents||0)/100).toFixed(2).replace('.', ',') + ' €';
  }
})();
